import "./navigation.scss";
import { images } from "../../constants";
import { FaMapMarkerAlt, FaSearch, FaShoppingCart } from "react-icons/fa";

const Navigation = () => {
  return (
    <nav className="navigation">
      <img src={images.Logo} alt="logo" />

      <div className="nav-links">
        <p>SHOP</p>
        <p>FOOD</p>
        <p>BABY</p>
        <p>CONSULT</p>
        <p>LAB TEST</p>
        <p>WELLNESS</p>
        <p>PACKAGES</p>
        <p>FINANCE</p>
        <p>ADD-ONS</p>
        <p>MAMATALK</p>
      </div>

      <div className="nav-search">
        <input type="text" placeholder="Search" />
        <span>
          <FaSearch />
        </span>
      </div>
      <button type="button">Login</button>
      <div className='location-div'>
        <FaMapMarkerAlt />
        <select>
          <option>
            All Over India
          </option>
          <option>Delhi</option>
          <option>Mumbai</option>
          <option>Kolkata</option>
          <option>Haryana</option>
          <option>Lucknow</option>
          <option>Hyderabad</option>
          <option>Chennai</option>
          <option>Other</option>
        </select>
      </div>
      <FaShoppingCart/>
    </nav>
  );
};

export default Navigation;
